export const HOTSPOT_MODAL_VIDEO_ENDED = 'HotspotModal.VIDEO_ENDED'
export const HOTSPOT_MODAL_VIDEO_PLAY = 'HotspotModal.VIDEO_PLAY'
export const HOTSPOT_MODAL_VIDEO_PAUSE = 'HotspotModal.VIDEO_PAUSE'
export const HOTSPOT_MODAL_VIDEO_DRAGEND = 'HotspotModal.VIDEO_DRAGEN'

export const hotspotModalVideoEnded = () => ({
    type: HOTSPOT_MODAL_VIDEO_ENDED,
})

export const hotspotModalVideoPlay = () => ({
    type: HOTSPOT_MODAL_VIDEO_PLAY,
})

export const hotspotModalVideoPause = () => ({
    type: HOTSPOT_MODAL_VIDEO_PAUSE,
})

export const hotspotModalVideoDragEnd = () => ({
    type: HOTSPOT_MODAL_VIDEO_DRAGEND,
})
